// DOM
const encodedTextElements = document.querySelectorAll('[data-sg-decode]');
const encodedHrefElements = document.querySelectorAll('[data-sg-decode-href]');

// State
let hasDom = false;

// http://web.archive.org/web/20240924152921/https://andrewlock.net/simple-obfuscation-of-email-addresses-using-javascript/
function decodeString(encodedString) {

    let output = ''; 
    
    // Extract the first 2 letters
    const keyInHex = encodedString.substr(0, 2);

    // Convert the hex-encoded key into decimal
    const key = parseInt(keyInHex, 16);

    // Loop through the remaining encoded characters in steps of 2
    for (let n = 2; n < encodedString.length; n += 2) {
        
        // Get the next pair of characters
        const charInHex = encodedString.substr(n, 2)
        
        // Convert hex to decimal
        const char = parseInt(charInHex, 16);

        // XOR the character with the key to get the original character
        const original = char ^ key;

        // Append the decoded character to the output
        output += String.fromCharCode(original);
    }

    return output;
}

function decode() {
    encodedTextElements.forEach(element => {
        const decodedString = decodeString(element.textContent.trim());
        element.textContent = decodedString;
    });
    encodedHrefElements.forEach(element => {
        const decodedString = decodeString(element.dataset.sgDecodeHref.trim());
        element.href = decodedString;
    });
}

function init() {
    hasDom = encodedTextElements || encodedHrefElements;
    if ( ! hasDom) return;

    decode();
}

export default {
    init
}
